<template>
	<div class="queue">
		<div class="queue-text">
			<img src="./text.png" alt="" class="queue-text__image">
		</div>
		<div class="queue-group">
			<div class="queue-group__item" :class="{ calling: call_type.includes(item.table_type_id) }" v-for="item in nums"
				:key="item.id">{{ item.sn }}</div>
		</div>
	</div>
</template>

<script>
export default {

	name: 'Queue',
	props: {
		// 定义 message 属性
		nums: {
			type: Array,
			default: [],
			required: true
		},
		call_type: {
			type: Array,
			default: [],
			required: true
		}
	},

	data() {
		return {

		}
	}
}
</script>

<style scoped>
.queue {
	height: 100%;
	display: flex;
	align-items: center;
	background: url("./texture.png") no-repeat center center / cover;
	overflow: hidden;
}

.queue-text {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	width: 24.25rem;
	background: url("./text-bg.png") no-repeat center center / cover;
	padding: 1.5rem 4.5rem;
	max-width: 40%;
}

.queue-text__image {
	width: 15.0625rem;
	display: block;
	object-fit: contain;
}

.queue-group {
	flex: 1 0 0;
	height: 100%;
	display: flex;
}

.queue-group__item {
	flex: 1 0 0;
	color: var(--primary);
	font-size: 6.7rem;
	padding: 1.25rem;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	user-select: none;
}

.queue-group__item+.queue-group__item::before {
	content: "";
	position: absolute;
	left: 0;
	top: 10%;
	width: 0.3125rem;
	height: 80%;
	transform: translateX(-50%);
	background: url("./dot.png") no-repeat center center / 100%;
}

@keyframes color-animation {
	0% {
		color: #8E886E;
	}

	/* 动画开始时的颜色 */
	50% {
		color: #5F8287;
	}

	/* 动画中间时的颜色 */
	100% {
		color: #8E886E;
	}

	/* 动画结束时的颜色 */
}

.calling {
	animation-name: color-animation;
	animation-duration: 2s;
	/* 动画持续时间 */
	animation-iteration-count: infinite;
	/* 动画重复次数，这里设置为无限循环 */
}
</style>
